import { MyTeamReviewCompletions, MyTeamReviewDeadlines } from '.';

const MyTeamReview = () => {
  return (
    <div>
      <div>
        <MyTeamReviewCompletions completionStatus="expiring" />
      </div>
      <div style={{ marginTop: 50 }}>
        <MyTeamReviewCompletions completionStatus="expired" />
      </div>
      <div style={{ marginTop: 50 }}>
        <MyTeamReviewDeadlines />
      </div>
      <div style={{ marginTop: 50 }}>
        <MyTeamReviewDeadlines expired={true} />
      </div>
    </div>
  );
};

export default MyTeamReview;
